import store from '../store/index'

import { createRouter, createWebHistory } from "vue-router"
import DevMainPage from "../views/DevMainPage.vue";
import MainPage from "../views/MainPage.vue";
// import CustomerInfo from '../views/customer/CustomerInfo.vue'
// import CustomerManage from '../views/customer/CustomerManage.vue'
import DentalCustomerInfo from '../views/customer/DentalCustomerInfo.vue'
//import DentalCustomerManage from '../views/customer/DentalCustomerManage.vue'
import FingerCustomerInfo from '../views/customer/FingerCustomerInfo.vue'
//import FingerCustomerManage from '../views/customer/FingerCustomerManage'
import PetCustomerInfo from '../views/customer/PetCustomerInfo.vue'
import SnsCustomerInfo from '../views/customer/SnsCustomerInfo.vue'
import HospitalCustomerInfo from '../views/customer/HospitalCustomerInfo.vue'
import PlannerInfo from '../views/planner/PlannerInfo.vue'
import PlannerManage from '../views/planner/PlannerManage.vue'
import StatisticsDental from '../views/statistics/Dental.vue'
import StatisticsComplain from '../views/statistics/Complain.vue'
import DentalForm from '../views/DentalForm.vue'
import MenuManage from '../views/hondidorang/MenuManage.vue'
import AdoptionInfo from '../views/hondidorang/AdoptionInfo.vue'
import HospitalManage from '../views/hondidorang/HospitalManage.vue'
import RescueManage from '../views/hondidorang/RescueManage.vue'
import Itsm from '../views/setting/ITSM.vue'
import SiteManage from '../views/setting/SiteManage.vue'
import NoticeManage from '../views/setting/NoticeManage.vue'
import DbManage from '../views/setting/DbManage.vue'
import AlarmManage from '../views/setting/AlarmManage.vue'
import Signin from "../views/Signin.vue"
import ChangePassword from "../views/setting/ChangePassword.vue"
import RequestDB from '../views/setting/RequestDB.vue'
import DevTools from "../views/setting/DevTools.vue"

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/main-page",
  },

  {
    path: "/devMain",
    name: "개발팀 메인",
    component: DevMainPage,
  },

  {
    path: "/main-page",
    name: "메인",
    component: MainPage,
    meta: {
      menuKey: 'all'
    }
  },

  {
    path: "/customer-info-dental",
    name: "고객 정보 - 치과",
    component: DentalCustomerInfo,
    meta: {
      menuKey: 'dental'
    }
  },

  {
    path: "/customer-info-finger",
    name: "고객 정보 - 지문",
    component: FingerCustomerInfo,
    meta: {
      menuKey: 'finger'
    }
  },

  {
    path: "/customer-info-pet",
    name: "고객 정보 - 혼디도랑",
    component: PetCustomerInfo,
    meta: {
      menuKey: 'pet'
    }
  },

  {
    path: "/customer-info-sns",
    name: "고객 정보 - 사이트 & SNS",
    component: SnsCustomerInfo,
    meta: {
      menuKey: 'sns'
    }
  },

  {
    path: "/customer-info-hospital",
    name: "고객 정보 - 동물병원",
    component: HospitalCustomerInfo,
    meta: {
      menuKey: 'hospital'
    }
  },

  {
    path: "/planner-info",
    name: "플래너 정보",
    component: PlannerInfo,
  },

  {
    path: "/planner-manage",
    name: "플래너 관리",
    component: PlannerManage,
  },

  {
    path: "/statistics-dental",
    name: "통계-치과DB건수",
    component: StatisticsDental,
  },

  {
    path: "/statistics-complain",
    name: "통계-컴플레인",
    component: StatisticsComplain,
  },

  {
    path: "/dental-form",
    name: "치과청구확인서 양식",
    component: DentalForm,
  },

  {
    path: "/menu-manage",
    name: "메뉴 관리",
    component: MenuManage,
  },

  {
    path: "/adoption-info",
    name: "입양 현황 관리",
    component: AdoptionInfo,
  },

  {
    path: "/hospital-manage",
    name: "동물병원 관리",
    component: HospitalManage,
  },

  {
    path: "/rescue-manage",
    name: "구조 현황 관리",
    component: RescueManage,
  },

  {
    path: "/itsm",
    name: "사이트 수정 요청",
    component: Itsm,
  },

  {
    path: "/setting",
    name: "설정",
    component: SiteManage,
  },

  {
    path: "/notice-manage",
    name: "공지사항 관리",
    component: NoticeManage,
  },

  {
    path: "/db-manage",
    name: "DB 관리",
    component: DbManage,
    meta: {
      menuKey: 'dental'
    }
  },

  {
    path: "/request-db",
    name: "DB 요청",
    component: RequestDB,
  },

  {
    path: "/alarm-manage",
    name: "알림 설정",
    component: AlarmManage,
  },

  {
    path: "/change-password",
    name: "비밀번호 변경",
    component: ChangePassword,
  },

  {
    path: "/devTools",
    name: "개발용",
    component: DevTools,
  },

  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },

  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  if(to.meta.menuKey){
    store.commit('setDBKind', to.meta.menuKey);
  }
  next();
})

export default router;
